import { fromNow } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import {
  useOpenAvailabilityDetailsAction,
  useChangeAvailabilityStatusAction
} from '../_actions/useAvailabilityActionsList'
import { useOpenNonCompliancesCountByPlaceId } from '../list/_load/OpenNonCompliancesCountsLoader'
import Button from '../../../packages/kiti/components/actions/Button'
import Draggable from '../../../components/dnd/Draggable'
import Link from '../../../components/actions/Link'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { SmallText, Text } from '../../../components/presentation/Text'

export const CARD_DND_TYPE = 'AVAILABILITY_CARD'

const AvailabilityCard = ({ item }) => {
  const { t } = useTranslation('availability')
  const canEdit = useSessionPermission('editPlaceAvailabilityStatus')
  const countByPlaceId = useOpenNonCompliancesCountByPlaceId()
  const details = useOpenAvailabilityDetailsAction(item)
  const changeStatus = useChangeAvailabilityStatusAction(item)

  return (
    <Draggable type={CARD_DND_TYPE} item={{ id: item.id, reference: item.id }} useMoveCursor>
      <Panel bgColor="white" borderColor="light3">
        <Link onClick={details.click} block>
          <Text bold color="dark2" breakWord>
            {item.name}
          </Text>
          <SmallText color="dark3" breakWord>
            {item.resume}
          </SmallText>
        </Link>

        <Separator weight={2} />

        <SmallText color="dark3">
          {t('openNonCompliances')}: {countByPlaceId[item.id] ?? 0}
        </SmallText>

        {item.availabilityStatusOrigin && (
          <SmallText color="dark3">
            {t('origin')}: {t(`origin.${item.availabilityStatusOrigin}`)}
          </SmallText>
        )}

        {item.availabilityStatusChangedAt && (
          <SmallText color="dark3">
            {t('changedAt')}: {fromNow(item.availabilityStatusChangedAt)}
          </SmallText>
        )}

        {canEdit && (
          <>
            <Separator weight={2} />
            <Button transparent color="dark3" size="small" onClick={changeStatus.click}>
              {t('changeStatusManually')}
            </Button>
          </>
        )}
      </Panel>
    </Draggable>
  )
}

export default AvailabilityCard
